// extracted by mini-css-extract-plugin
export default {"label":"Styles_label__KAS8Q","value":"Styles_value__X38u7"};